import { IUserState } from 'store/types/user'
import { IUser } from 'types/user'

export const getInitialState = (): IUserState => ({
  isLoading: false,
  data: {} as IUser,
  activeHighestSubscription: {
    data: null,
    isLoading: false
  },
  userStats: null,
  userCurrentTariffId: 0,
  unlimitedAiImageModelIds: [],
  unlimitedAiVideoModels: []
})
